module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "fill-height": "",
      "column": ""
    }
  }, [(!_vm.noHeader) ? _c('div', {
    staticClass: "header mx-3 mt-3"
  }, [_vm._t("header")], 2) : _vm._e(), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_vm._t("default")], 2), (!_vm.noFooter) ? _c('div', {
    staticClass: "pa-3"
  }, [_vm._t("footer")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6899dae9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.common/uikit/components/simple-page.vue
// module id = 336
// module chunks = 0